import request from "@/utils/request";

// 充电二维码

// 生成固定二维码
export const generatePermanentQRCode = data => {
	return request({
		url: "/device/qrcode/permanent",
		method: "POST",
		data,
	});
};
